module.exports = __webpack_public_path__ + "img/banner-alaska.0a1e9821.jpg";